import {SearchPageType} from '../../../search-config';
import {getDocumentPreviewApiUrl, getFilePreviewApiUrl, getHighlightApiUrl} from '../../../../services/search-service';
import {AbortCategory, fetchFile, fetchWithBody, postJsonWithBody} from '../../../../services/fetcher';
import {HibuDocumentPreviewResponse, HibuHighlightResponse} from '../../../../common/pdf-viewer/PdfViewer.types';
import {PreviewDocument} from './docPreviewRow-types';
import {Buffer} from 'buffer';
import {SpotlightTagType} from '../../../../config/config-types';
import {HibuHitDoc} from '../../../search-types';
import {getCurrentLanguage} from '../../../../i18n-service';
import {getErrorMessage} from '../../../../utils/utils';

export async function fetchPlainDocument(
    searchPageType: SearchPageType,
    documentId: string,
    containerName: string,
): Promise<HibuHitDoc | undefined> {
    const previewRequest = {
        container: containerName,
        displayLanguage: getCurrentLanguage(),
        documentId: documentId,
    };
    try {
        const response = await postJsonWithBody<HibuDocumentPreviewResponse | undefined>(
            getDocumentPreviewApiUrl(searchPageType),
            JSON.stringify(previewRequest),
            AbortCategory.DETAILS,
        );

        return response?.doc;
    } catch (error) {
        console.log(error);
        return undefined;
    }
}

export async function fetchPdfDocument(
    previewLink: string,
): Promise<PreviewDocument | undefined> {
    try {
        const response: Blob = await fetchFile(
            getFilePreviewApiUrl(SearchPageType.BASIC),
            JSON.stringify({link: previewLink}),
            AbortCategory.PREVIEW);
        if (response) {
            return {
                documentBlob: response,
            };
        }
        return undefined;
    } catch (error: any) {
        console.log('Error: ', getErrorMessage(error));
        return {
            error: error,
        };
    }
}

function base64ToBlobData(str: string) {
    const fileDataProcessed = Buffer.from(str, 'base64').toString('binary');
    return Buffer.from(fileDataProcessed, 'base64');
}

export async function fetchHighlightedDocument(
    docId: string,
    query: string,
    containerName: string,
    highlightTags: boolean,
    spotlightTagTypes: SpotlightTagType[],
    previewPath?: string,
    contentType?: string,
): Promise<PreviewDocument | undefined> {
    const location = getHighlightApiUrl(SearchPageType.BASIC);
    const language = getCurrentLanguage();
    const hlRequest = {
        container: containerName,
        documentId: docId,
        relativeFilePath: previewPath,
        query: query,
        language: language,
        fields: ['content', 'title'],
        highlightTags: highlightTags,
        highlightTagTypes: spotlightTagTypes.map((h) => h.name),
        contentType: contentType,
    };
    return fetchWithBody<HibuHighlightResponse | undefined>(
        location,
        'POST',
        JSON.stringify(hlRequest),
        AbortCategory.PREVIEW,
    )
        .then((data?: HibuHighlightResponse) => {
            if (!data) {
                return; // Fetch was aborted.
            }
            if (data.fileBytes === undefined) {
                return {
                    title: data.textWithHighlights?.title,
                    content: data.textWithHighlights?.content,
                };
            } else {
                const decodedPdf = base64ToBlobData(data.fileBytes);
                const blob = new Blob([decodedPdf], {type: 'application/pdf'});
                console.log('blob', blob);
                return {
                    documentBlob: blob,
                    title: data.textWithHighlights?.title,
                    content: data.textWithHighlights?.content,
                };
            }
        })
        .catch((error: any) => {
            console.log('Error: ', getErrorMessage(error));
            return undefined;
        });
}
